var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-block",
    "data-name": "Icon material-block",
    d: "M13,3A10,10,0,1,0,23,13,10,10,0,0,0,13,3ZM5,13a8,8,0,0,1,8-8,7.9,7.9,0,0,1,4.9,1.69L6.69,17.9A7.9,7.9,0,0,1,5,13Zm8,8a7.9,7.9,0,0,1-4.9-1.69L19.31,8.1A7.9,7.9,0,0,1,21,13,8,8,0,0,1,13,21Z",
    transform: "translate(-3 -3)",
    fill: "#ef466f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.2675a8745b99d11cdd96cf6ee0245ab3.svg";
export { ForwardRef as ReactComponent };